import React, { useMemo } from 'react'
import { Grid } from 'semantic-ui-react'
import {
  CERNER,
  EPIC,
  ALLSCRIPTS
} from '@enlyt/base/constants/Items/MyHealth/index.nehr.js'

import styles from './styles'
import Image from 'next/image'

const IconCerner = '/media/icons/icon-cerner.svg'
const IconEpic = '/media/icons/icon-epic.svg'
const IconAllScripts = '/media/icons/icon-allscripts.svg'

const PanelItem = ({ item }) => {
  const icon = useMemo(() => {
    switch (item.name) {
      case CERNER:
        return IconCerner

      case EPIC:
        return IconEpic

      case ALLSCRIPTS:
        return IconAllScripts

      default:
        return ''
    }
  }, [item.name])

  return (
    <div style={styles.itemColumn}>
      <div style={{ flex: 1 }}>
        <Image
          src={icon}
          alt={item.name}
          fill
          unoptimized
          style={{ maxWidth: '100%', height: 'auto' }}
        />
        <p style={styles.itemName}>{item.name}</p>
        <p style={styles.subtitle}>{item.subtitle}</p>
      </div>
      <div style={styles.itemFooter}>
        <div style={styles.divider} />
        <p style={styles.itemView}>Connect ›</p>
      </div>
    </div>
  )
}

const PanelItems = ({ items }) => {
  return (
    <React.Fragment>
      {items.map(item => (
        <Grid.Column key={item.name}>
          <PanelItem item={item} />
        </Grid.Column>
      ))}
    </React.Fragment>
  )
}

export default PanelItems
